import { storeOutboundEventBus } from "src/shared/data-loading/outbound/bus/storeOutboundEventBus";
import { storeInboundEventBus } from "src/shared/data-loading/inbound/bus/storeInboundEventBus";
import handleInitializeCampaign from "src/shared/data-loading/outbound/campaign/handlers/initialize_campaign";
import handleInitializeCampaignSummaries from "src/shared/data-loading/outbound/campaign-summary/handlers/initialize_campaign_summaries";
import CampaignEndpoints from "src/shared/api/campaign/CampaignEndpoints";
import CampaignSummaryEndpoints from "src/shared/api/campaign/CampaignSummaryEndpoints";
import { once } from "lodash";
import { safeInitializeCampaign } from "./campaign/emitters/safeInitializeCampaign";
import ComponentEndpoints from "src/shared/api/campaign/component/ComponentEndpoints";
import handleInitializeComponent from "./component/handlers/initialize_component";
import { safeInitializeGlobalCampaign } from "./globalCampaign/emitters/safeInitializeGlobalCampaign";
import handleInitializeGlobalCampaign from "./globalCampaign/handlers/initialize_global_campaign";
import handleInitializeAllCampaigns from "./campaign/handlers/initialize_all_campaigns";
import handleCampaignHasBeenUpdated from "./campaign/handlers/campaign_has_been_updated";
import handleComponentHasBeenUpdated from "./component/handlers/component_has_been_updated";
import Session from "Session";
export const setupFakeWebSocket = once(() => {
    const sourceClientId = Session.getInstance().getClientId();
    storeOutboundEventBus.on("initialize_campaign", (payload) => {
        handleInitializeCampaign({
            payload,
            inboundEventBus: storeInboundEventBus,
            campaignEndpoints: CampaignEndpoints,
            campaignSummaryEndpoints: CampaignSummaryEndpoints,
            sourceClientId,
        });
    });
    storeOutboundEventBus.on("initialize_all_campaigns", () => {
        handleInitializeAllCampaigns({
            inboundEventBus: storeInboundEventBus,
            campaignEndpoints: CampaignEndpoints,
            sourceClientId,
        });
    });
    storeOutboundEventBus.on("campaign_has_been_updated", (payload) => {
        handleCampaignHasBeenUpdated({
            payload,
            inboundEventBus: storeInboundEventBus,
            campaignEndpoints: CampaignEndpoints,
            campaignSummaryEndpoints: CampaignSummaryEndpoints,
            sourceClientId,
        });
    });
    storeOutboundEventBus.on("initialize_component", (payload) => {
        handleInitializeComponent(payload, storeInboundEventBus, ComponentEndpoints, safeInitializeCampaign, safeInitializeGlobalCampaign);
    });
    storeOutboundEventBus.on("component_has_been_updated", (payload) => {
        handleComponentHasBeenUpdated(payload, ComponentEndpoints, storeInboundEventBus);
    });
    storeOutboundEventBus.on("initialize_global_campaign", () => {
        handleInitializeGlobalCampaign(CampaignSummaryEndpoints, safeInitializeCampaign);
    });
    storeOutboundEventBus.on("initialize_campaign_summaries", (payload) => {
        handleInitializeCampaignSummaries(payload, storeInboundEventBus, CampaignSummaryEndpoints);
    });
});
